package games.polyclub.website.frontend.store.layout

import adminlte.dropdown.Dropdown
import adminlte.dropdown.DropdownOperation
import games.polyclub.frontend.lib.messagerenderer.Viewer
import games.polyclub.frontend.lib.messagerenderer.m
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.message.BuildString
import games.polyclub.message.div
import games.polyclub.message.unaryMinus
import games.polyclub.service.player.id.api.MojangPlayerId
import games.polyclub.service.player.id.api.OnlineMojangPlayerId
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.appScope
import games.polyclub.website.frontend.store.components.AsyncImg
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.hooks.useLogout
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import jquery.jQuery
import kotlinx.coroutines.launch
import react.Props
import react.router.dom.Link
import react.router.useLocation

val TopBarUser = SFC<Props> { _ ->
    val authCtx = useAuth()
    val location = useLocation()
    val auth = authCtx.auth
    val logout = useLogout()
    if (auth != null) {
        val playerId = auth.profile.playerId
        li("nav-item dropdown user-menu") {
            a("nav-link dropdown-toggle") {
                href = "#"
                onClick = { event ->
                    event.preventDefault()
                    event.stopPropagation()

                    jQuery(event.currentTarget).Dropdown(DropdownOperation.TOGGLE_SUBMENU)
                        .siblings().css("display", "")
                }
                span("d-none d-md-inline"){
                    +auth.profile.currentName.name
                }
                if (playerId != null) {
                    AsyncImg("user-image img-circle elevation-2 mr-0 ml-3 flip") {
                        srcLoader = { StoreBff.avatarUrl(playerId) }
                        alt = -"Avatar ${"da"/auth} ${auth.profile.currentName.name}" - BuildString(Viewer)
                    }
                }
            }
            ul("dropdown-menu dropdown-menu-lg dropdown-menu-right") {
                li("user-header bg-primary") {
                    AsyncImg("img-circle elevation-2 flip") {
                        srcLoader = { StoreBff.avatarUrl(playerId ?: OnlineMojangPlayerId.MHF_Alex) }
                        alt = -"Avatar ${"da" / auth} ${auth.profile.currentName.name}" - BuildString(Viewer)
                    }
                    p {
                        +auth.profile.currentName.name
                        small {
                            val mojangId = (auth.profile.playerId as? MojangPlayerId)?.mojangId?.toString()
                            val networkId = auth.profile.playerId?.networkId?.toString()
                            +(mojangId ?: networkId ?: (-"<${"desvinculada"/auth}-do-minecraft>" - BuildString(Viewer)))
                        }
                    }
                }

                /*li("user-body") {
                    div("row") {
                        div("col-4 text-center") {
                            a {
                                href = "#"
                                +"Followers"
                            }
                        }
                        div("col-4 text-center") {
                            a {
                                href = "#"
                                +"Sales"
                            }
                        }
                        div("col-4 text-center") {
                            a {
                                href = "#"
                                +"Friends"
                            }
                        }
                    }

                }*/

                li("user-footer") {
                    Link("btn btn-default btn-flat") {
                        to = LoggedSitemap.HOME.path
                        m(-"Área ${"da"/auth} Cliente")
                    }
                    a("btn btn-default btn-flat float-right") {
                        href = "#"
                        onClick = { ev ->
                            ev.preventDefault()
                            appScope.launch {
                                logout()
                            }
                        }
                        +"Sair"
                    }
                }
            }
        }
    } else {
        li("nav-item") {
            Link("nav-link") {
                to = LoggedSitemap.HOME.path
                /*span("d-none d-md-inline") {
                    +auth.profile.currentName.name
                }*/
                +"Entrar / Registrar"
            }
        }
    }
}
